import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

import "./Devis.css";

const Devis = ({ selectedProduct }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("");

  const form = useRef();

  const devisHandler = (e) => {
    //
    e.preventDefault();

    // set them to empty values
    setName("");
    setEmail("");
    setMessage("");
    setPhone("");

    emailjs
      .sendForm(
        "service_ym072mc",
        "devis-template",
        form.current,
        "XIJYdEIZ6kSu_lJiT"
      )
      .then(
        (result) => {
          console.log("Email sent");
          // console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="add-review-sec">
      <h5>Demander un Devis: {selectedProduct.name}</h5>

      <div className="clearfix"></div>
      <form ref={form} onSubmit={devisHandler} className="review-form">
        <div className="form-field">
          <input
            type="text"
            name="name"
            placeholder="Nom"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="form-field">
          <input
            hidden
            type="text"
            name="equipement"
            value={selectedProduct.name}
            // onChange={(e)=>}
            placeholder="Nom"
          />
        </div>

        <div className="form-field">
          <input
            type="text"
            name="phone"
            placeholder="Telephone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>

        <div className="form-field">
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="form-field">
          <textarea
            name="message"
            placeholder="Message..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>
        </div>
        <div className="form-submit">
          <button type="submit" className="theme-btn">
            Envoyer
          </button>
        </div>
      </form>
    </div>
  );
};

export default Devis;
